import { ReactComponent as CalendarIcon } from '@/assets/icons/calendar-title.svg';
import { Box } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledCalendarIcon = styled(CalendarIcon, {});

export const StyledSectionTitle = styled(Box, {
  alignItems: 'stretch',
  display: 'flex',
  gap: '$2',
});
